import React from "react";
import { GiGong } from "react-icons/gi";

const StatCard = ({ label, value }) => (
  <div className="rounded-2xl bg-white/10 px-4 py-3 ring-1 ring-white/15">
    <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-300">
      {label}
    </p>
    <p className="mt-1 text-xl font-bold">{value}</p>
  </div>
);

const BracketHeader = ({ stats }) => {
  return (
    <div className="relative overflow-hidden border-b border-slate-200 bg-gradient-to-r from-slate-950 via-slate-900 to-blue-950 px-5 py-5 text-white dark:border-white/10">
      <div className="absolute -right-16 -top-20 h-48 w-48 rounded-full bg-blue-400/20 blur-3xl" />
      <div className="absolute -bottom-20 left-20 h-44 w-44 rounded-full bg-emerald-400/10 blur-3xl" />

      <div className="relative flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] text-blue-100 ring-1 ring-white/15">
            <GiGong />
            Tableau sans repêchage
          </div>

          <h2 className="mt-3 text-2xl font-bold tracking-tight">
            Tableau éliminatoire
          </h2>

          <p className="mt-1 max-w-2xl text-sm text-slate-300">
            Suivi visuel des combats, qualification automatique des exempts,
            avancement des vainqueurs et saisie rapide des résultats.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
          <StatCard label="Base" value={stats.baseSize} />
          <StatCard label="Combattants" value={stats.realCompetitorCount} />
          <StatCard label="Saisis" value={stats.completedCount} />
          <StatCard label="À jouer" value={stats.toPlayCount} />
        </div>
      </div>
    </div>
  );
};

export default BracketHeader;